export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 lg:px-10 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3">
          Ready to Start Shopping?
        </h2>
        <p className="text-white/80 text-sm md:text-base max-w-md mx-auto mb-8">
          Browse thousands of products from trusted spreadsheet sellers. Fast shipping, verified quality, and the best prices available.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-white text-primary-600 text-sm font-bold rounded-lg hover:bg-white/95 transition-colors whitespace-nowrap min-w-[180px]"
          >
            CSSBuy Sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-600 text-white text-sm font-bold rounded-lg hover:bg-primary-700 border border-white/20 transition-colors whitespace-nowrap min-w-[180px]"
          >
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}